<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <ul class="grid gap-x-5" style="grid-template-columns: auto 1fr">
        <el-form-item
          label="类型"
          prop="type"
          :rules="[{ required: true, message: '请选择类型', trigger: 'blur' }]"
        >
          <div
            class="rounded px-3 cursor-pointer"
            :class="
              state.model.type === 0
                ? ' bg-blue-500 text-white'
                : ' text-gray-400 border'
            "
            @click="state.model.type = 0"
          >
            充值
          </div>
          <div
            class="rounded px-3 ml-2 cursor-pointer"
            :class="
              state.model.type === 1
                ? ' bg-red-600 text-white'
                : ' text-gray-400 border'
            "
            @click="state.model.type = 1"
          >
            扣款
          </div>
        </el-form-item>
        <el-form-item
          label="金额"
          prop="money"
          :rules="[{ required: true, message: '请输入金额', trigger: 'blur' }]"
        >
          <el-input-number
            v-model="state.model.money"
            class="number-input-left number-input-suffix !w-full"
            precision="2"
            suffix="元"
          ></el-input-number>
        </el-form-item>
      </ul>
      <el-form-item label="备注">
        <el-input
          v-model="state.model.remark"
          type="textarea"
          :autosize="{
            minRows: 3,
          }"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { billunit_balanceChange } from "@/http/billunit";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    bill_unit_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        bill_unit_id: props.bill_unit_id,
      },
    });
    onMounted(() => {});

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid && props.bill_unit_id) {
          billunit_balanceChange(state.model).then((res) => {
            post_response(res, () => {
              setTimeout(() => {
                emit("close", true);
              }, 500);
            });
          });
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
